import { render, staticRenderFns } from "./IdentificationDocument.vue?vue&type=template&id=3744055f&scoped=true"
import script from "./IdentificationDocument.vue?vue&type=script&lang=js"
export * from "./IdentificationDocument.vue?vue&type=script&lang=js"
import style0 from "./IdentificationDocument.vue?vue&type=style&index=0&id=3744055f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3744055f",
  null
  
)

export default component.exports